/** "partially_fulfilled" → "Partially fulfilled": how stored enum values read in the simulator. */
export const humanize = (value: string): string => {
  const words = value.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};
